import { EditPatientDrawer } from '../../household/patient/EditPatientDrawer';
import { IQueryParamDrivenDrawerContentProvider } from './IQueryParamDrivenDrawerContentProvider';
import { AppointmentEditorDrawer } from '../../appointments/AppointmentEditorDrawer';
import { ViewNoteWithQueryParamDrawer } from '../../notes/view-note/ViewNoteWithQueryParamDrawer';
import { EditNoteWithQueryParamDrawer } from '../../notes/edit-note/EditNoteWithQueryParamDrawer';
import { AddNoteWithQueryParamDrawer } from '../../notes/add-note/AddNoteWithQueryParamDrawer';
import { AddCommunityPostWithQueryParamDrawer } from '../../community/AddCommunityPostWithQueryParamDrawer';
import { EditCommunityPostWithQueryParamDrawer } from '../../community/EditCommunityPostWIthQueryParamDrawer';
import { ViewCommunityPostWithQueryParamDrawer } from '../../community/ViewCommunityPostWithQueryParamDrawer';
import { MedicationEditorDrawer } from '../../household/patient/MedicationEditorDrawer';
import { AllergyEditorDrawer } from '../../household/AllergyEditorDrawer';
import { DiagnosisEditorDrawer } from '../../household/DiagnosisEditorDrawer';

export class QueryParamDrivenDrawerCompositeContentProvider {
    static inject = () => [
        EditPatientDrawer,
        ViewNoteWithQueryParamDrawer,
        EditNoteWithQueryParamDrawer,
        AppointmentEditorDrawer,
        AddNoteWithQueryParamDrawer,
        AddCommunityPostWithQueryParamDrawer,
        EditCommunityPostWithQueryParamDrawer,
        ViewCommunityPostWithQueryParamDrawer,
        MedicationEditorDrawer,
        AllergyEditorDrawer,
        DiagnosisEditorDrawer
    ];

    constructor(...providers: IQueryParamDrivenDrawerContentProvider[]){
        this.providers = providers;
    }

    private providers: IQueryParamDrivenDrawerContentProvider[];

    getComponent = (params: { mode: string; [key: string]: any; }) => {
        const provider = this.providers.find(p => p.mode === params.mode);
        if (!provider){
            throw new Error(`failed to find drawer provider for mode ${params.mode}`);
        }
        return provider!.Component!;
    };

    getOptions = (mode: string) => {
        const provider = this.providers.find(p => p.mode === mode);
        if (!provider){
            throw new Error(`failed to find drawer provider for mode ${mode}`);
        }
        return provider!.options!;
    };
}
